import { create } from "zustand";
import { api } from "@/lib/api";
import { useWorkshop } from "./workshop";

export interface User {
  id: string;
  email: string;
  name: string;
  organization: string;
  department: string | null;
  jobTitle: string | null;
  phone: string;
  role: "learner" | "admin";
  license: "standard" | "enterprise";
  emailVerifiedAt: string | null;
  verifiedCompanyEmail: string | null;
  consentMarketing: boolean;
  createdAt: string;
}

export interface SignupInput {
  email: string;
  password: string;
  name: string;
  organization: string;
  department?: string;
  jobTitle?: string;
  phone: string;
  consentPrivacy: true;
  consentMarketing: boolean;
}

interface AuthState {
  user: User | null;
  /** 첫 /me 확인이 끝났는가 , 끝나기 전에는 로그인 화면으로 튕기지 않는다 */
  ready: boolean;
  load: () => Promise<void>;
  login: (email: string, password: string) => Promise<void>;
  signup: (input: SignupInput) => Promise<void>;
  logout: () => Promise<void>;
  updateProfile: (patch: Partial<Pick<User, "name" | "organization" | "department" | "jobTitle" | "phone" | "consentMarketing">>) => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  ready: false,
  async load() {
    try {
      const r = await api<{ user: User | null }>("/auth/me");
      useWorkshop.getState().setDraftOwner(r.user?.id ?? null);
      set({ user: r.user, ready: true });
    } catch {
      useWorkshop.getState().setDraftOwner(null);
      set({ user: null, ready: true });
    }
  },
  async login(email, password) {
    const r = await api<{ user: User }>("/auth/login", { method: "POST", json: { email, password } });
    useWorkshop.getState().setDraftOwner(r.user?.id ?? null);
    set({ user: r.user, ready: true });
  },
  async signup(input) {
    const r = await api<{ user: User }>("/auth/signup", { method: "POST", json: input });
    useWorkshop.getState().setDraftOwner(r.user?.id ?? null);
    set({ user: r.user, ready: true });
  },
  async logout() {
    await api("/auth/logout", { method: "POST" });
    useWorkshop.getState().setDraftOwner(null);
    set({ user: null });
  },
  async updateProfile(patch) {
    const r = await api<{ user: User }>("/auth/me", { method: "PATCH", json: patch });
    set({ user: r.user });
  },
}));
